export default __webpack_public_path__ + "static/media/marque.73a25f29.jpg";